import React from 'react';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import styles from './EmployeeAssociationModal.css';
import gobizLogoUrl from './gobiz-logo.png';
import mokaLogoUrl from './moka-logo.png';

function EmployeeAssociationModal(props) {
  const { moka, hermes, onClose } = props;

  return (
    <Modal show>
      <Modal.Header>
        <Modal.Title>Employee Association</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>This employee is associated with a GoBiz account.</p>

        <div className={styles.infoCardRow}>
          <div className={styles.infoCard}>
            <div>
              <img src={mokaLogoUrl} alt="Moka Logo" />
            </div>
            <div className={styles.infoCardDetails}>
              <div className={styles.infoCardDetailsRow}>
                <div className={styles.infoCardLabel}>Email</div>
                <div className={styles.infoCardValue}>{moka.email}</div>
              </div>
              <div className={styles.infoCardDetailsRow}>
                <div className={styles.infoCardLabel}>Phone</div>
                <div className={styles.infoCardValue}>{moka.phone}</div>
              </div>
            </div>
          </div>

          <div className={styles.infoCard}>
            <div>
              <img src={gobizLogoUrl} alt="GoBiz Logo" />
            </div>
            <div className={styles.infoCardDetails}>
              <div className={styles.infoCardDetailsRow}>
                <div className={styles.infoCardLabel}>Email</div>
                <div className={styles.infoCardValue}>{hermes.email}</div>
              </div>
              <div className={styles.infoCardDetailsRow}>
                <div className={styles.infoCardLabel}>Phone</div>
                <div className={styles.infoCardValue}>{hermes.phone}</div>
              </div>
            </div>
          </div>
        </div>

        <p className={styles.footNote}>
          If you have any concern about this, please call our customer service
          at <b>1500970</b>
        </p>
      </Modal.Body>

      <Modal.Footer className={styles.footer}>
        <button
          type="button"
          className={classNames('btn btn-primary', styles.confirmButton)}
          onClick={onClose}
        >
          Got It
        </button>
      </Modal.Footer>
    </Modal>
  );
}

EmployeeAssociationModal.defaultProps = {
  moka: {},
  hermes: {},
  onClose: () => {},
};

export default EmployeeAssociationModal;
